// 브라우저 alert()·confirm() 대신 쓰는 화면 안 확인창(components/common/common-message-dialog.vue)을 어디서든 부른다.
// 아이폰 홈 화면 앱에서 브라우저 확인창이 막혀서 만들었다.
//   if (!(await this.$confirm("삭제하시겠습니까?"))) return;
//   await this.$alert("삭제되었습니다");
//
// 창은 <v-app> 이 있는 DefaultTemplate 이 하나씩 띄우고 register/unregister 로 알려 준다.
// v-dialog 는 처음 열릴 때 본문을 그때의 <v-app> 으로 옮기고 다시 옮기지 않는데, <v-app> 은 페이지마다 새로 생긴다.
// 그래서 AppMain 에 하나만 두면 페이지를 옮긴 뒤 창 본문이 사라진다(어두운 배경만 뜸).
// 페이지가 바뀌는 순간 새 템플릿과 옛 템플릿이 잠깐 같이 있을 수 있어 목록으로 두고 가장 최근 것을 쓴다
import Vue from "vue";

let dialogs = [];

export function register(instance) {
    dialogs.push(instance);
}

export function unregister(instance) {
    dialogs = dialogs.filter((dialog) => dialog !== instance);
}

function target() {
    if (!dialogs.length) throw new Error("[message-dialog] 화면에 common-message-dialog 가 등록되지 않았습니다(DefaultTemplate)");
    return dialogs[dialogs.length - 1];
}

/** @returns {Promise<void>} */
export function alert(message) {
    return target().alert(message);
}

/** @returns {Promise<boolean>} 확인을 누르면 true */
export function confirm(message) {
    return target().confirm(message);
}

Vue.use({
    install(Vue) {
        Vue.prototype.$alert = alert;
        Vue.prototype.$confirm = confirm;
    },
});
